import { DepotForm } from "@features/stock/components/DepotForm";
import { API_ENDPOINTS, ROUTES } from "@features/stock/config/constants";
import api from "@lib/api";
import { queryKeys } from "@lib/api/queryKeys";
import { usePermissions } from "@lib/hooks/usePermissions";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/depots/$id/edit")({
  loader: requirePermission(PERMISSIONS.STOCK.DEPOTS.EDIT),
  component: EditDepotComponent,
});

function EditDepotComponent() {
  const { id } = Route.useParams();
  const { can } = usePermissions();
  const navigate = useNavigate();

  const { data, isLoading: isDepotLoading } = useQuery({
    queryKey: queryKeys.stock.depots.detail(Number(id)),
    queryFn: async () => {
      const response = await api.get(API_ENDPOINTS.DEPOTS.DETAIL(id));
      const depot = response.data;
      // Normalize societe to ID
      if (depot.societe) {
        if (typeof depot.societe === "string") {
          // IRI format: /api/filiales/2
          const parts = depot.societe.split("/");
          depot.societe = parseInt(parts[parts.length - 1], 10);
        } else if (typeof depot.societe === "object" && depot.societe.id) {
          depot.societe = depot.societe.id;
        }
      }
      return depot;
    },
  });

  if (!can(PERMISSIONS.STOCK.DEPOTS.EDIT)) {
    return <div className="p-6">Accès non autorisé</div>;
  }

  if (isDepotLoading) {
    return <div className="p-6">Chargement...</div>;
  }

  const handleSuccess = () => {
    navigate({ to: ROUTES.STOCK.DEPOTS.LIST });
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Modifier Dépôt</h1>
      {data && <DepotForm key={data.id} mode="edit" initialData={data} onSuccess={handleSuccess} />}
    </div>
  );
}
